/**
 * Cookiebot consent helpers (AR-269).
 *
 * The Cookiebot script is injected in `client/index.html` and exposes a global
 * `Cookiebot` object once loaded. It is a third-party script that can legitimately
 * be absent (not yet loaded, blocked by an extension, offline), so every access
 * here is optional and callers must handle "not available".
 */

interface CookiebotApi {
  /** Re-opens the consent dialog with the visitor's current selection pre-filled. */
  renew: () => void;
}

declare global {
  interface Window {
    Cookiebot?: CookiebotApi;
  }
}

/** Fired on `window` by Cookiebot once its API is ready. */
export const COOKIEBOT_LOAD_EVENT = 'CookiebotOnLoad';

export function isCookiebotAvailable(): boolean {
  return typeof window !== 'undefined' && typeof window.Cookiebot?.renew === 'function';
}

/** Opens the Cookiebot preferences dialog. No-op when Cookiebot is unavailable. */
export function openCookiePreferences(): void {
  window.Cookiebot?.renew();
}
